import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, vModelText as _vModelText, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "tab-shell" }
const _hoisted_2 = { class: "tab-head" }
const _hoisted_3 = {
  key: 0,
  class: "form-card"
}
const _hoisted_4 = { class: "form-title" }
const _hoisted_5 = { class: "form-grid" }
const _hoisted_6 = { class: "field" }
const _hoisted_7 = { class: "field" }
const _hoisted_8 = { class: "field" }
const _hoisted_9 = { class: "field" }
const _hoisted_10 = { class: "field" }
const _hoisted_11 = { class: "field" }
const _hoisted_12 = { class: "field field--full" }
const _hoisted_13 = { class: "field field--full" }
const _hoisted_14 = {
  key: 0,
  class: "form-error"
}
const _hoisted_15 = { class: "form-actions" }
const _hoisted_16 = ["disabled"]
const _hoisted_17 = {
  key: 1,
  class: "empty-hint"
}
const _hoisted_18 = {
  key: 2,
  class: "empty-hint"
}
const _hoisted_19 = {
  key: 3,
  class: "cards-grid"
}
const _hoisted_20 = { class: "card-body" }
const _hoisted_21 = { class: "card-title" }
const _hoisted_22 = {
  key: 0,
  class: "card-meta"
}
const _hoisted_23 = {
  key: 1,
  class: "card-meta"
}
const _hoisted_24 = {
  key: 2,
  class: "card-meta"
}
const _hoisted_25 = {
  key: 3,
  class: "card-meta"
}
const _hoisted_26 = {
  key: 4,
  class: "card-meta"
}
const _hoisted_27 = {
  key: 5,
  class: "chip-row"
}
const _hoisted_28 = { class: "card-footer" }
const _hoisted_29 = ["onClick"]
const _hoisted_30 = ["onClick"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _cache[13] || (_cache[13] = _createElementVNode("h2", { class: "tab-title" }, "Fornecedores", -1)),
      (!_ctx.showForm)
        ? (_openBlock(), _createElementBlock("button", {
            key: 0,
            class: "btn-primary",
            type: "button",
            onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.openForm()))
          }, [...(_cache[12] || (_cache[12] = [
            _createElementVNode("svg", {
              width: "13",
              height: "13",
              viewBox: "0 0 24 24",
              fill: "none",
              stroke: "currentColor",
              "stroke-width": "2.2"
            }, [
              _createElementVNode("line", {
                x1: "12",
                y1: "5",
                x2: "12",
                y2: "19"
              }),
              _createElementVNode("line", {
                x1: "5",
                y1: "12",
                x2: "19",
                y2: "12"
              })
            ], -1),
            _createTextVNode(" Novo Fornecedor ", -1)
          ]))]))
        : _createCommentVNode("", true)
    ]),
    (_ctx.showForm)
      ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
          _createElementVNode("h3", _hoisted_4, _toDisplayString(_ctx.editId ? 'Editar Fornecedor' : 'Novo Fornecedor'), 1),
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("label", _hoisted_6, [
              _cache[14] || (_cache[14] = _createElementVNode("span", { class: "field-label" }, "CNPJ", -1)),
              _withDirectives(_createElementVNode("input", {
                class: "field-input",
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.form.cnpj) = $event)),
                placeholder: "00.000.000/0000-00",
                maxlength: "18",
                onInput: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.maskCnpj && _ctx.maskCnpj(...args)))
              }, null, 544), [
                [_vModelText, _ctx.form.cnpj]
              ])
            ]),
            _createElementVNode("label", _hoisted_7, [
              _cache[15] || (_cache[15] = _createElementVNode("span", { class: "field-label" }, "Razão Social *", -1)),
              _withDirectives(_createElementVNode("input", {
                class: "field-input",
                "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.form.razaoSocial) = $event)),
                placeholder: "Nome da empresa"
              }, null, 512), [
                [_vModelText, _ctx.form.razaoSocial]
              ])
            ]),
            _createElementVNode("label", _hoisted_8, [
              _cache[16] || (_cache[16] = _createElementVNode("span", { class: "field-label" }, "Nome Fantasia", -1)),
              _withDirectives(_createElementVNode("input", {
                class: "field-input",
                "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.form.nomeFantasia) = $event)),
                placeholder: "Como é conhecido"
              }, null, 512), [
                [_vModelText, _ctx.form.nomeFantasia]
              ])
            ]),
            _createElementVNode("label", _hoisted_9, [
              _cache[17] || (_cache[17] = _createElementVNode("span", { class: "field-label" }, "Telefone", -1)),
              _withDirectives(_createElementVNode("input", {
                class: "field-input",
                "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.form.telefone) = $event)),
                placeholder: "(11) 99999-9999"
              }, null, 512), [
                [_vModelText, _ctx.form.telefone]
              ])
            ]),
            _createElementVNode("label", _hoisted_10, [
              _cache[18] || (_cache[18] = _createElementVNode("span", { class: "field-label" }, "E-mail", -1)),
              _withDirectives(_createElementVNode("input", {
                class: "field-input",
                type: "email",
                "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.form.email) = $event)),
                placeholder: "contato@empresa.com"
              }, null, 512), [
                [_vModelText, _ctx.form.email]
              ])
            ]),
            _createElementVNode("label", _hoisted_11, [
              _cache[19] || (_cache[19] = _createElementVNode("span", { class: "field-label" }, "Condição de Pagamento", -1)),
              _withDirectives(_createElementVNode("input", {
                class: "field-input",
                "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.form.condicaoPagamento) = $event)),
                placeholder: "Ex: 30 dias, boleto"
              }, null, 512), [
                [_vModelText, _ctx.form.condicaoPagamento]
              ])
            ]),
            _createElementVNode("label", _hoisted_12, [
              _cache[20] || (_cache[20] = _createElementVNode("span", { class: "field-label" }, "Categorias (vírgula para separar)", -1)),
              _withDirectives(_createElementVNode("input", {
                class: "field-input",
                "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.categoriasText) = $event)),
                placeholder: "materiais, ferramentas, serviços"
              }, null, 512), [
                [_vModelText, _ctx.categoriasText]
              ])
            ]),
            _createElementVNode("label", _hoisted_13, [
              _cache[21] || (_cache[21] = _createElementVNode("span", { class: "field-label" }, "Observações", -1)),
              _withDirectives(_createElementVNode("textarea", {
                class: "field-input field-textarea",
                "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.form.notes) = $event)),
                rows: "2",
                placeholder: "Notas internas"
              }, null, 512), [
                [_vModelText, _ctx.form.notes]
              ])
            ])
          ]),
          (_ctx.formError)
            ? (_openBlock(), _createElementBlock("p", _hoisted_14, _toDisplayString(_ctx.formError), 1))
            : _createCommentVNode("", true),
          _createElementVNode("div", _hoisted_15, [
            _createElementVNode("button", {
              class: "btn-save",
              type: "button",
              disabled: _ctx.saving,
              onClick: _cache[10] || (_cache[10] = 
//@ts-ignore
(...args) => (_ctx.save && _ctx.save(...args)))
            }, _toDisplayString(_ctx.saving ? 'Salvando...' : 'Salvar'), 9, _hoisted_16),
            _createElementVNode("button", {
              class: "btn-cancel",
              type: "button",
              onClick: _cache[11] || (_cache[11] = 
//@ts-ignore
(...args) => (_ctx.closeForm && _ctx.closeForm(...args)))
            }, "Cancelar")
          ])
        ]))
      : _createCommentVNode("", true),
    (_ctx.loading)
      ? (_openBlock(), _createElementBlock("div", _hoisted_17, "Carregando..."))
      : (_ctx.suppliers.length === 0 && !_ctx.showForm)
        ? (_openBlock(), _createElementBlock("div", _hoisted_18, [...(_cache[22] || (_cache[22] = [
            _createElementVNode("svg", {
              width: "36",
              height: "36",
              viewBox: "0 0 24 24",
              fill: "none",
              stroke: "currentColor",
              "stroke-width": "1.4"
            }, [
              _createElementVNode("rect", {
                x: "2",
                y: "7",
                width: "20",
                height: "14",
                rx: "2"
              }),
              _createElementVNode("path", { d: "M16 7V5a2 2 0 0 0-2-2h-4a2 2 0 0 0-2 2v2" })
            ], -1),
            _createTextVNode(" Nenhum fornecedor cadastrado. ", -1)
          ]))]))
        : (_openBlock(), _createElementBlock("div", _hoisted_19, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.suppliers, (s) => {
              return (_openBlock(), _createElementBlock("article", {
                key: s.id,
                class: "supplier-card"
              }, [
                _createElementVNode("div", _hoisted_20, [
                  _createElementVNode("div", _hoisted_21, _toDisplayString(s.nomeFantasia || s.razaoSocial), 1),
                  (s.nomeFantasia)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_22, _toDisplayString(s.razaoSocial), 1))
                    : _createCommentVNode("", true),
                  (s.cnpj)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_23, "CNPJ: " + _toDisplayString(_ctx.formatCnpj(s.cnpj)), 1))
                    : _createCommentVNode("", true),
                  (s.telefone)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_24, _toDisplayString(s.telefone), 1))
                    : _createCommentVNode("", true),
                  (s.email)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_25, _toDisplayString(s.email), 1))
                    : _createCommentVNode("", true),
                  (s.condicaoPagamento)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_26, "Pagamento: " + _toDisplayString(s.condicaoPagamento), 1))
                    : _createCommentVNode("", true),
                  (_ctx.parsedCategorias(s).length)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_27, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.parsedCategorias(s), (cat) => {
                          return (_openBlock(), _createElementBlock("span", {
                            key: cat,
                            class: "cat-chip"
                          }, _toDisplayString(cat), 1))
                        }), 128))
                      ]))
                    : _createCommentVNode("", true)
                ]),
                _createElementVNode("div", _hoisted_28, [
                  _createElementVNode("button", {
                    class: "card-btn",
                    type: "button",
                    onClick: ($event: any) => (_ctx.openForm(s))
                  }, "Editar", 8, _hoisted_29),
                  _createElementVNode("button", {
                    class: "card-btn card-btn--warn",
                    type: "button",
                    onClick: ($event: any) => (_ctx.remove(s.id))
                  }, "Excluir", 8, _hoisted_30)
                ])
              ]))
            }), 128))
          ]))
  ]))
}